module.exports = __webpack_public_path__ + "img/luxury.2f2df9f2.svg";